import React from 'react';
import { Link } from 'react-router-dom';

const LPFooter = () => {
  return (
    <footer className="bg-slate-900 text-slate-400 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-sm">&copy; {new Date().getFullYear()} Trademark Throne. All rights reserved.</p>
          <div className="mt-3 flex items-center justify-center gap-6 text-sm">
            <Link to="/privacy" className="hover:text-[#D4AF37] transition-colors">Privacy Policy</Link>
            <span className="text-slate-700">|</span>
            <Link to="/terms" className="hover:text-[#D4AF37] transition-colors">Terms of Service</Link>
          </div>
          <p className="mt-3 text-xs text-slate-600">
            Trademark registration services provided by licensed attorneys.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LPFooter;
